import { Box } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";

interface ExpirationStatusBadgeProps {
  value: number;
  isExpired: boolean;
}

export const ExpirationStatusBadge = ({
  value,
  isExpired,
}: ExpirationStatusBadgeProps) => {
  if (isExpired) {
    return (
      <Box
        sx={{
          bgcolor: "#fee2e2",
          color: "#991b1b",
          px: 2,
          py: 1,
          borderRadius: 1,
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        {Vocabulary.isExpired} de {value} {Vocabulary.months}
      </Box>
    );
  }
  if (value <= 3) {
    return (
      <Box
        sx={{
          bgcolor: "#fef3c7",
          color: "#92400e",
          px: 2,
          py: 1,
          borderRadius: 1,
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        {Vocabulary.expireIn} {value} {Vocabulary.months}
      </Box>
    );
  }
  return (
    <Box sx={{ textAlign: "center" }}>
      {value} {Vocabulary.months}
    </Box>
  );
};
